import React from "react";

import { get } from "lodash";
import { getIcon } from "../../helpers/icons";
import { dateTime } from "../../helpers/date";
import Link from "../Link";
import Title from "../../components/Title";
import AsyncGet from "../../components/AsyncGet";

import style from "./style.module.css";

export default function PaymentHistory(props) {
    const {
        closeDialog = "",
    } = props;

    return (
        <div className={`${style.feedback} ${style.changePlan} ${style.popupArea}`}>
            <div className={style.popupWrap}>
                <div className={style.sectionHeader}>
                    <>
                        <Link
                            className={`${style.dialogClose}`}
                            onClick={closeDialog}
                        >
                            <i className={getIcon("Arrow-left")}></i>
                        </Link>
                        <Title className="fontTeko" transform="uppercase" tag="h2">View Payment History</Title>
                    </>
                </div>
                <div className={style.sectionBody}>
                    <div className={style.tableresposive}>
                        <table className={style.paymentHistoryTable}>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Membership</th>
                                    <th>Paid</th>
                                </tr>
                            </thead>
                            <tbody>
                                <AsyncGet
                                    url={`payment/history`}
                                    permissionText={false}
                                    loadOnMount={true}
                                    render={({ data }) => {
                                        if(data) {
                                            return (
                                                <>
                                                {
                                                    data.list.length > 0 && data.list.map((item, index) => {
                                                        return (
                                                            <tr>
                                                                <td>{dateTime(get(item, 'created_at'), "MMM DD, Y")}</td>
                                                                <td>{get(item, 'plan.full_title')}</td>
                                                                <td>£{get(item, 'plan.price')}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </>
                                            )
                                            
                                        }
                                    }}
                                />
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}